/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { historyByParentByTime } from "../../graphql/queries";

import {
  ArrayField,
  Datagrid,
  TextField,
  DateField,
  Labeled,
} from "react-admin";
import { logError } from "../../utils/appUtils";

const fetchHistoryNotes = async (record, setHistoryNotes) => {
  try {
    let allHistoryNotes = [];
    let nextToken = null;
    const limit = 1000;

    do {
      const input = {
        parentId: record.id,
        limit,
        nextToken,
        sortDirection: "DESC",
      };
      const response = await API.graphql(
        graphqlOperation(historyByParentByTime, input)
      );

      const historyNotes = response.data.historyByParentByTime.items || [];
      allHistoryNotes = allHistoryNotes.concat(historyNotes);
      nextToken = response.data.historyByParentByTime.nextToken;
    } while (nextToken);

    setHistoryNotes({ items: allHistoryNotes });
  } catch (error) {
    logError("HistoryTab:fetchHistoryNotes", error, false);
  }
};

export const HistoryTab = (props) => {
  const [historyNotes, setHistoryNotes] = useState([]);
  const { record } = props;
  const historyRecord = historyNotes.items?.length > 0 ? historyNotes : record;
  const source =
    historyRecord?.items?.length > 0
      ? "items"
      : historyRecord?.history?.length > 0
      ? "history"
      : "items";

  useEffect(() => {
    fetchHistoryNotes(record, setHistoryNotes);
  }, [record]);

  return (
    <Labeled label="EVENT HISTORY" fullWidth>
      <ArrayField source={source} record={historyRecord}>
        <Datagrid>
          <TextField source="text" label="Event" />
          {source.includes("items") ? (
            <DateField source="dateTime" label="Event Time" showTime={true} />
          ) : (
            <DateField source="date" label="Event Time" showTime={true} />
          )}
          {source.includes("items") ? (
            <TextField source="createdBy" label="Performed By" />
          ) : (
            <TextField source="by" label="Performed By" />
          )}
        </Datagrid>
      </ArrayField>
    </Labeled>
  );
};
